import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import Input from "@mui/material/Input";
import TextField from "@mui/material/TextField";
import { EMPLOYEE_BLUE, PINK_RED, WHITE } from "../colors";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import HeightBox from "./HeightBox";
import EmployeeService from "../services/employeeService";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CustomTextField = styled(TextField)(({ theme }) => ({
  width: 400,
  height: 30,
  backgroundColor: "#E1DEDE",
  paddingLeft: 10,
  borderRadius: 24,
  "& input": {
    padding: "5px 10px",
  },
  "& fieldset": {
    border: "none",
  },
  "&:hover": {
    backgroundColor: "#E9E9E9",
  },
  "&:focus": {
    backgroundColor: "#E9E9E9",
    boxShadow: "0 0 0 2px rgba(66, 133, 244, 0.3)",
  },
  "& .MuiInput-underline:before": {
    borderBottom: "none",
  },
  "& .MuiInput-underline:after": {
    borderBottom: "none",
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 721,
  borderRadius: 10,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  bgcolor: "#E1DEDE",
  boxShadow: 24,
  p: 4,
};

const CustomButton = styled(Button)(({ theme }) => ({
  height: 40,
  minWidth: 180,
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
  color: WHITE,
}));

export default function ChangePasswordModel(props) {
  const { okFunction, openModel, cancelFunction } = props;

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = React.useState({
    password: "",
    confirmPassword: "",
  });

  const resetPassword = async () => {
    setLoading(true);
    const res = await EmployeeService.resetPasswordEmployee(props.user.id, {
      password: formData.password,
    });

    setFormData({ password: "", confirmPassword: "" });
    setLoading(false);
    cancelFunction();
  };
  useEffect(() => {}, [formData.areEqual]);

  return (
    <Modal
      open={openModel}
      onClose={() => {
        setFormData({ password: "", confirmPassword: "" });
        cancelFunction();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="delete"
          onClick={cancelFunction}
          sx={{ position: "absolute", right: "20px", top: "20px" }}
        >
          <CloseIcon />
        </IconButton>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Change Password
        </Typography>
        <HeightBox height={40} />
        <Stack direction="column" alignItems="center" spacing={3}>
          {/* <CustomTextField placeholder="Current Password" /> */}

          <CustomTextField
            type="password"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
            placeholder="New Password"
          />

          <CustomTextField
            placeholder="Confirm New Password"
            type="password"
            value={formData.confirmPassword}
            onChange={(e) => {
              if (formData.password !== e.target.value) {
                setFormData({ ...formData, areEqual: false });
              } else {
                setFormData({ ...formData, areEqual: true });
              }
              setFormData({ ...formData, confirmPassword: e.target.value });
            }}
          />
          {formData.confirmPassword !== formData.password && (
            <p style={{ textAlign: "left", width: "100%", color: "red" }}>
              Passwords don't match
            </p>
          )}
        </Stack>
        <HeightBox height={40} />
        <Stack direction="row" alignItems="center" spacing={3}>
          <CustomButton
            style={{ backgroundColor: PINK_RED }}
            onClick={() => {
              setFormData({ password: "", confirmPassword: "" });
              setLoading(false);
              cancelFunction();
            }}
          >
            Cancel
          </CustomButton>
          <CustomButton
            style={{ backgroundColor: EMPLOYEE_BLUE }}
            disabled={
              loading ||
              formData.password === "" ||
              formData.confirmPassword !== formData.password
            }
            onClick={() => {
              setLoading(true);
              resetPassword();
            }}
          >
            {loading ? <CircularProgress size={15} /> : " Change Password"}
          </CustomButton>
        </Stack>
      </Box>
    </Modal>
  );
}
